import React from 'react';

const BuscarFicha = props => (
  <div className='pageHead-rowContainer'>
    <div className='pageHead-filters wrapper'>
      <div className='pageHead-filters-search'>
        <div className='fSearch'>
          <div className='fSearch-filter form-control'>
            <select className='searchOption' value={props.typeSearch} name={props.selectName} onChange={props.onChangeInput}>
              <option value='nfdv'>N° FDV</option>
              <option value='nproforma'>N° Proforma</option>
                <option value='npedido'>N° Pedido</option>
            </select>
          </div>
          <input
            type='text'
            className='fSearch-search form-control'
            name={props.inputName}
            value={props.inputValue}
            onChange={props.onChangeInput}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                props.searchFDV(props.inputValue);
              }
            }}
          />
          <button className='btn btn-dark fSearch-go' onClick={() => props.searchFDV(props.inputValue)}>
            <i className='ion-android-arrow-forward' />
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default BuscarFicha;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/BuscarFicha.js